// auto-generated
import type {SearchHitsMetadata, SearchResponse, SortResults} from '@elastic/elasticsearch/lib/api/types';
import type {EPeople} from '@local/elastic/document-types/people';
import {ObjectUtil} from '@local/util/objectUtil';

const indexPattern = /^v[0-9]+-people$/;
export class EPeopleConverter {
  private logger: Logger | undefined;
  constructor(arg?: {logger?: Logger}) {
    this.logger = arg?.logger;
  }
  handle = (arg: SearchResponse): Return => {
    const hits: SearchHitsMetadata<any> = arg.hits;
    return hits.hits.reduce<Return>((res, h) => {
      if (!indexPattern.test(h._index)) {
        return res;
      }
      const source = h._source;
      const data = ObjectUtil.removeUndefined({
        people_id: source.people_id,
        organization_id: source.organization_id,
        persona_id: source.persona_id,
        default_persona_id: source.default_persona_id,
        user_id: source.user_id,
        code: source.code,
        email: source.email,
        tel: source.tel,
        name: source.name,
        first_name: source.first_name,
        family_name: source.family_name,
        system_roles: source.system_roles,
        invitation: source.invitation
          ? {
              id: source.invitation.id,
              expire_at: source.invitation.expire_at,
              status: source.invitation.status,
            }
          : undefined,
        created_at: source.created_at,
        updated_at: source.updated_at,
      });
      const result: Return[number] = {data};
      if (h.highlight) {
        result.highlight = h.highlight;
      }
      if (h._score) {
        result._score = h._score;
      }
      if (h.sort) {
        result.sort = h.sort;
      }
      res.push(result);
      return res;
    }, []);
  };
}
type Return = {data: EPeople; highlight?: Record<string, string[]>; _score?: number; sort?: SortResults}[];
type Logger = {
  warn: (message: string, data: Record<string, any>) => any;
};
